/** @format */

import PropTypes from "prop-types";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { assetUrl } from "fusion-core";

const ModalWrapper = ({
  heading = "Modal Title",
  simpleText,
  buttonText = null,
  showClose = true,
  onClose,
  onButtonClick,
  buttonType = "button",
  showCheckbox = false,
  checkboxLabel = "",
  checkboxChecked = false,
  checkboxError = "",
  onCheckboxChange,
  children,
}) => {
  const css = assetUrl("../../styles/ModalWrapper.css");

  return (
    <>
      <Helmet>
        <link rel="stylesheet" href={css} />
      </Helmet>
      <div className="modal-wrapper-parent">
        <div className="modal-wrapper-backdrop"></div>
        <div className="modal-wrapper-container">
          <div className="modal-wrapper-header">
            {showClose && (
              <button
                className="modal-wrapper-close-button"
                onClick={onClose}
                aria-label="Close"
              >
                &#x2715;
              </button>
            )}
            <h2 className="modal-wrapper-heading">{heading}</h2>
          </div>
          <div className="modal-wrapper-content">
            {simpleText && <p className="modal-wrapper-text">{simpleText}</p>}
            {children}
            {showCheckbox && (
              <div className="modal-wrapper-checkbox-container">
                <input
                  type="checkbox"
                  id="modalWrapperCheckbox"
                  checked={checkboxChecked}
                  onChange={onCheckboxChange}
                />
                <div className="modal-wrapper-checkbox-label-container">
                  <label
                    htmlFor="modalWrapperCheckbox"
                    className="modal-wrapper-checkbox-label"
                  >
                    {checkboxLabel}
                  </label>
                  {checkboxError && (
                    <span className="modal-wrapper-checkbox-error">
                      {checkboxError}
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
          {buttonText && (
            <button
              type={buttonType}
              className={`modal-wrapper-button ${
                showCheckbox && !checkboxChecked
                  ? " modal-wrapper-button-disabled"
                  : " modal-wrapper-button-enabled"
              }`}
              onClick={onButtonClick}
            >
              {buttonText}
            </button>
          )}
        </div>
      </div>
    </>
  );
};

ModalWrapper.propTypes = {
  heading: PropTypes.string,
  simpleText: PropTypes.node,
  buttonText: PropTypes.string,
  showClose: PropTypes.bool,
  onClose: PropTypes.func,
  onButtonClick: PropTypes.func,
  showCheckbox: PropTypes.bool,
  checkboxLabel: PropTypes.node,
  checkboxChecked: PropTypes.bool,
  checkboxError: PropTypes.string,
  onCheckboxChange: PropTypes.func,
  children: PropTypes.node,
};

export default ModalWrapper;
